<template>
    <div>
        <v-col cols="12" md6 offset-md="0" class="pa-0">
            <span>Настройки подключения WhatsApp {{botModel.instance}} 789</span>
            <v-divider ></v-divider>
            <v-checkbox class="pa-0 ma-1 mx-2"
                        v-model="botModel.instance"
                        label="Допуск подключения бота к WhatsApp (Выдается после запроса в администрацию сайта)"
                        readonly
                        color="success"
                        :true-value="1"
                        :false-value="0"
                        success-text="false"
                        hide-details
            ></v-checkbox>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-3" v-show="qrCode != null">
            <span>Осталось {{seconds}} секунд</span>
            <img alt="" :src="qrCode" title="Зайдите в настройки WhatsApp и наведите камеру телефона на этот qr код"/>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-1" v-show="botModel.instance != 0 && botModel.instance">
            <v-btn @click="getStatus" color="primary" text small><span class="text-none">Статус</span></v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-1" v-show="botModel.instance != 0 && botModel.instance">
            <v-btn @click="quitConnection" color="primary" text small><span class="text-none">Выйти из аккаунта</span></v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-1" v-show="botModel.instance != 0 && botModel.instance">
            <v-btn @click="activateSession" color="primary" text small>
                <span class="text-none">Активировать чат-бота в веб клиенте</span>
                </v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 my-1" v-if="user.user_id == 1">
            <v-btn @click="setWebHookWa" color="primary" text small>
                <span class="text-none">Обновить веб хук</span>
                </v-btn>
        </v-col>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios'
import constConf from '../../../constconf'
import { mapGetters } from 'vuex'
export default {
    name: 'BotFormConnectTg',
    components: {
    },
    data() {
        return {
            visSelectGroupVkDialog: false,
            visSettingGroupVkDialog: false,
            mailingParam: true,
            qrCode: null,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            seconds: 60
        }
    },
    props: ['botModel'],
    computed: {
        token_tg() {
            return this.botModel.token_tg === '1' ? '' : this.botModel.token_tg
        },
        ...mapGetters({
            user: 'user/user'
        })
    },
    methods: {
        getStatus() {
            axios.defaults.withCredentials = true
            axios.get(
                constConf.bot.url + '/bot/get-status-wa/' + this.botModel.id
            )
                .then((response) => {
                    if (!response.data.response.data.hasOwnProperty('error')) {
                        this.paramsSnackbar.color = 'success'
                        if (response.data.response.data.accountStatus === 'got qr code') {
                            this.qrCode = response.data.response.data.qrCode
                            let seconds = setInterval(() => {
                                this.seconds = this.seconds - 1
                                if (this.seconds <= 0) {
                                    clearInterval(seconds) // остановка функции
                                    this.qrCode = null
                                }
                            }, 1000)
                            this.seconds = 60
                        }
                        if (response.data.response.data.accountStatus === 'authenticated') {
                            this.qrCode = null
                        }
                    } else {
                        this.qrCode = null
                        this.paramsSnackbar.color = 'error'
                    }
                    this.paramsSnackbar.text = response.data.response.text
                    this.snackbar = true
                })
                .catch((error) => {
                    console.log('Ошибка при группы')
                    console.log(error)
                })
        },
        quitConnection() {
            axios.defaults.withCredentials = true
            axios.get(
                constConf.bot.url + '/bot/quit-connection-wa/' + this.botModel.id
            )
                .then((response) => {
                    if (!response.data.response.data.hasOwnProperty('error')) {
                        this.paramsSnackbar.color = 'success'
                    } else {
                        this.paramsSnackbar.color = 'error'
                    }
                    this.qrCode = null
                    this.paramsSnackbar.text = response.data.response.text
                    this.snackbar = true
                })
                .catch((error) => {
                    console.log('Ошибка при группы')
                    console.log(error)
                })
        },
        activateSession() {
            axios.defaults.withCredentials = true
            axios.get(
                constConf.bot.url + '/bot/activate-session-wa/' + this.botModel.id
            )
                .then((response) => {
                    if (!response.data.response.data.hasOwnProperty('error')) {
                        this.paramsSnackbar.color = 'success'
                    } else {
                        this.paramsSnackbar.color = 'error'
                    }
                    this.qrCode = null
                    this.paramsSnackbar.text = response.data.response.text
                    this.snackbar = true
                })
                .catch((error) => {
                    console.log('Ошибка при группы')
                    console.log(error)
                })
        },
        setWebHookWa() {
            this.$store.dispatch('bots/setWebHookWa', { bot_id: this.botModel.id })
        },
        showSelectGroupDialog(mailingParam) {
            this.mailingParam = mailingParam
            this.visSelectGroupVkDialog = true
        }
    }
}
</script>

<style scoped>

</style>
